'use client'

import { X } from 'lucide-react'
import { Dialog, DialogClose, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { useAuthDialogStore } from './auth-dialog.store'
import { Dictionary } from '@/localization/dictionary'
import LoginFormWrapper from './login-form-wrapper'
import Text from '../text'
import { Button } from '@/components/ui/button'
import Link from 'next/link'
import { useCartCount, withCartStoreSuspense } from '@/stores/cart-store'

interface AuthDialogProps {
  dict: {
    loginForm: Dictionary['loginForm']
    forgotPasswordForm: Dictionary['forgotPasswordForm']
  }
}

const AuthDialog = ({ dict }: AuthDialogProps) => {
  const showDialog = useAuthDialogStore()((s) => s.showDialog)
  const toggleShowDialog = useAuthDialogStore()((s) => s.toggleShowDialog)
  const cartCount = useCartCount()

  return (
    <Dialog open={showDialog} onOpenChange={toggleShowDialog}>
      <DialogContent
        aria-describedby={undefined}
        onOpenAutoFocus={(e) => e.preventDefault()}
        className="p-0 max-sm:h-screen max-sm:w-screen max-sm:max-w-none sm:max-w-[451px]"
      >
        <DialogTitle className="sr-only">{dict.loginForm.title}</DialogTitle>
        <div className="flex flex-col items-center px-5 pb-12.5 pt-6 sm:px-13.5 sm:py-6">
          <div className="mb-7 flex w-full justify-end">
            <DialogClose>
              <X className="size-6 text-black" strokeWidth={1} />
            </DialogClose>
          </div>

          <LoginFormWrapper
            title={
              <Text
                as="h4"
                uppercase
                className="mb-7.5 text-center text-secondary-900"
                markdown
              >
                {dict.loginForm.title}
              </Text>
            }
            onSuccess={toggleShowDialog}
            register={
              cartCount > 0 && (
                <div className="mt-5 flex w-full flex-col items-center gap-4">
                  <Text as="p">{dict.loginForm.noAccount}</Text>
                  <Button variant="outline" className="w-full" asChild>
                    <Link href="/checkout/user" onClick={toggleShowDialog}>
                      <Text as="p" uppercase>
                        {dict.loginForm.register}
                      </Text>
                    </Link>
                  </Button>
                </div>
              )
            }
            dict={{
              loginForm: dict.loginForm,
              forgotPasswordForm: dict.forgotPasswordForm,
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default withCartStoreSuspense(AuthDialog)
